import React, {useEffect, useRef} from 'react'
import {useFormContext} from 'react-hook-form'
import {Label} from './Label'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Additional classes
   */
  className?: string
  /**
   * Input name
   */
  name: string
  /**
   * Input Label
   */
  label?: string
  /**
   * Extra info will be shown next to label
   */
  info?: string | React.ReactElement
  /**
   * Placeholder
   */
  placeholder?: string
  /**
   * Additional icon
   */
  icon?: React.ReactNode
  /**
   * Input type. default: text
   */
  type?: string
  /**
   * Flag for auto focus when item rendered
   */
  autoFocus?: boolean

  autocomplete?: string
  limit: number
}

export const LimitedInput = ({
  type = 'text',
  className,
  name,
  label,
  info = '',
  placeholder = ' ',
  icon,
  autocomplete = 'on',
  disabled,
  limit = 120,
}: Props) => {
  const {
    register,
    formState: {errors},
    // @ts-ignore
    defaultValues,
  } = useFormContext() || {}
  const error = errors[name] as any

  const iconClasses = !!icon && `pr-10`
  const counter = useRef<HTMLDivElement>(null)
  const handleKeyUp = e => {
    if (counter) {
      const count = limit - e.currentTarget.value?.length
      counter.current.innerText = String(count < 0 ? 0 : count)
    }
  }

  useEffect(() => {
    if (counter)
      counter.current.innerText = String(limit - defaultValues[name]?.length)
    // eslint-disable-next-line
  }, [])

  return (
    <React.Fragment>
      {label && (
        <Label
          className="font-semibold"
          htmlFor={name}
          label={label}
          info={info}
        />
      )}
      <div className="relative text-form-icon focus-within:text-focus-icon">
        <input
          type={type}
          placeholder={placeholder}
          className={`border rounded p-2 w-full 
             focus:outline-none font-form
             text-form 
             border-form-border
             placeholder-form-placeholder
             focus:text-focus 
             focus:border-focus-border 
             focus:placeholder-focus-placeholder
             text-sm
              ${className}
             ${iconClasses}
            `}
          onKeyUp={handleKeyUp}
          {...(name ? register(name) : {})}
          autoComplete={autocomplete}
          maxLength={limit}
          disabled={disabled}
        />
        <div className="customIcon absolute inset-y-0 right-0 pr-3 flex items-center">
          {icon}
        </div>
      </div>
      {error && <p className="text-alert pt-1.5 text-xs">{error.message}</p>}
      <div className="text-xs text-gray-500 text-right">
        <span ref={counter}>{limit}</span> characters left
      </div>
    </React.Fragment>
  )
}
